<proffeo-ui-dialog [title]="'company-projects.modals.create-project-title' | translate">
  <mat-stepper
    #stepper
    [linear]="true"
    [disableRipple]="true"
  >
    <mat-step [completed]="form().valid()">
      <!--
      <ng-template matStepLabel>
        <ng-container
          *ngTemplateOutlet="stepLabelTemplate; context: { translationKey: 'company-projects.modals.project-first-step' }"
        ></ng-container>
      </ng-template>
-->
      <proffeo-project-basic-information
        (goToEditDraftCompanyProject)="goToEditDraftCompanyProject($event)"
        [form]="form"
        [isAddProjectModal]="true"
      ></proffeo-project-basic-information>
    </mat-step>
    <mat-step>
      <!--
      <ng-template matStepLabel>
        <ng-container
          *ngTemplateOutlet="stepLabelTemplate; context: { translationKey: 'company-projects.modals.project-second-step' }"
        ></ng-container>
      </ng-template>-->
    </mat-step>
    <mat-step>
      <!--
      <ng-template matStepLabel>
        <ng-container
          *ngTemplateOutlet="stepLabelTemplate; context: { translationKey: 'company-projects.modals.project-third-step' }"
        ></ng-container>
      </ng-template>
-->
    </mat-step>
    <mat-step>
      <!--
      <ng-template matStepLabel>
        <ng-container
          *ngTemplateOutlet="stepLabelTemplate; context: { translationKey: 'company-projects.modals.project-fourth-step' }"
        ></ng-container>
      </ng-template>
-->
    </mat-step>
  </mat-stepper>
  <div
    dialog-actions
    class="flex w-full justify-end items-center gap-2"
  >
    <proffeo-ui-button
      (clicked)="close()"
      [text]="'company-projects.modals.buttons-cancel' | translate"
      variant="primary"
    ></proffeo-ui-button>

    @if (stepper.selectedIndex === 0) {
      <proffeo-ui-button
        (clicked)="saveProject()"
        [disabled]="form().submitting()"
        [text]="'company-projects.modals.buttons-save' | translate"
        variant="accent"
      ></proffeo-ui-button>
    } @else {
      <proffeo-ui-button
        (clicked)="stepper.previous()"
        [text]="'company-projects.modals.buttons-back' | translate"
        variant="secondary"
      ></proffeo-ui-button>
    }
  </div>
</proffeo-ui-dialog>

<ng-template
  #stepLabelTemplate
  let-translationKey="translationKey"
>
  <p class="px-0.5 text-sm text-proffeo-text">
    {{ translationKey | translate }}
  </p>
</ng-template>
